import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ "name" ]

  warning() {
    const element = this.nameTarget
    const name = element.value
    const id = element.id
    const checked = element.checked
    let pregnancyWarning = document.getElementById('pregancy-warning')
    let buttonNext = document.getElementById('button-next')
    console.log(`Hello, ${id}!`)
    if (id === 'custom_field_pregnancy_value' || id === 'custom_field_recent_childbirth_value') {
      if (checked === true) {
        element.setAttribute("data-warning", "");
        pregnancyWarning.classList.remove('lg:hidden', 'hidden')
        pregnancyWarning.scrollIntoView({block: "center", behavior: "smooth"})
        buttonNext.disabled = true
      } else {
        element.removeAttribute("data-warning");
        if (document.querySelectorAll('[data-warning]').length == 0) {
          pregnancyWarning.classList.add('lg:hidden', 'hidden')
          buttonNext.disabled = false
        }
      }
    }
  }
}